import { render, staticRenderFns } from "./brInvalidIndex.vue?vue&type=template&id=06ec2ea2&scoped=true"
import script from "./brInvalidIndex.vue?vue&type=script&lang=js"
export * from "./brInvalidIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ec2ea2",
  null
  
)

export default component.exports